export default __webpack_public_path__ + "assets/sun-solid.svg";